export enum JobVacancyPhaseTypeEnum {
  Prescreening = 'prescreening',
  Screening = 'screening',
  Technical = 'technical',
  Topgrading = 'topgrading',
  Offer = 'offer',
}

export const JobVacancyPhaseTypeEnumLabels: Record<JobVacancyPhaseTypeEnum, string> = {
  [JobVacancyPhaseTypeEnum.Prescreening]: 'Prescreening',
  [JobVacancyPhaseTypeEnum.Screening]: 'Screening',
  [JobVacancyPhaseTypeEnum.Technical]: 'Técnica',
  [JobVacancyPhaseTypeEnum.Topgrading]: 'Topgrading',
  [JobVacancyPhaseTypeEnum.Offer]: 'Oferta',
};

export const JobVacancyPhaseTypeEnumIcons: Record<JobVacancyPhaseTypeEnum, string> = {
  [JobVacancyPhaseTypeEnum.Prescreening]: 'manage_search',
  [JobVacancyPhaseTypeEnum.Screening]: 'forum',
  [JobVacancyPhaseTypeEnum.Technical]: 'terminal',
  [JobVacancyPhaseTypeEnum.Topgrading]: 'groups',
  [JobVacancyPhaseTypeEnum.Offer]: 'handshake',
};
